import React from 'react'
import View from '../../../View/components/View'
import { config } from '../../../../config/Structure'
import styled from 'styled-components'

const SizesTable = () => {  

  return(
    <div>
      <TableHolder>
      <View componentName='sizes' config={config.sizes} />

      </TableHolder>
    </div>
  )
}

export default SizesTable



const TableHolder  = styled.div`
@media (max-width:767px){
  td:nth-child(2), td:nth-child(3) {
    display: inline-block;
    text-align: center;
  }
}

`